import React from "react"
import { ShelfItemBookEntity } from "@/app/entities/ShelfEntity"
import { toBookItemProps, isValidIsbn } from "../_utils/entityConverter"

interface BookItemProps {
  book: ShelfItemBookEntity
  isSelected: boolean
  onToggle: (isbn: string) => void
}

/**
 * 개별 도서 아이템 컴포넌트
 * Entity를 Props로 변환하여 UI에 표시
 */
const BookItem = React.memo<BookItemProps>(({ book, isSelected, onToggle }) => {
  const bookProps = toBookItemProps(book)
  const hasValidIsbn = isValidIsbn(book.isbn)

  const handleClick = () => {
    if (hasValidIsbn && book.isbn) {
      onToggle(book.isbn)
    }
  }

  return (
    <div className="bg-rl-common-white border-rl-border_line-light-03 box-border flex h-20 w-full flex-none flex-row items-center gap-4 rounded-xl border px-4 py-3 sm:max-w-none">
      {/* Book List Container */}
      <div
        className="flex h-16 flex-1 cursor-pointer flex-row items-center gap-1"
        onClick={handleClick}
      >
        {/* Book Image */}
        <div className="relative flex h-14 w-14 flex-shrink-0 items-center justify-center">
          <div className="border-rl-border_line-light-03 mt-[2px] box-border h-14 w-[37px] overflow-hidden rounded-[4px] border border-solid bg-gray-50 bg-cover bg-center">
            {bookProps.thumbnailUrl && (
              <img
                src={bookProps.thumbnailUrl}
                alt={bookProps.title}
                className="h-full w-full object-cover"
              />
            )}
          </div>
        </div>

        {/* Book Info */}
        <div className="flex min-w-0 flex-1 flex-col items-start justify-center pr-2">
          <h3 className="mb-0 line-clamp-2 w-full overflow-hidden text-[15px] leading-[142.9%] font-bold text-black">
            {bookProps.title}
          </h3>
          <p className="line-clamp-1 w-full text-[13px] leading-[138.5%] font-normal text-[#777777] opacity-80">
            {bookProps.authors}
          </p>
        </div>
      </div>

      {/* Checkbox */}
      <button
        onClick={handleClick}
        disabled={!hasValidIsbn}
        className={`order-1 flex h-6 w-6 flex-none flex-grow-0 items-center justify-center rounded-full transition-all duration-200 ${
          hasValidIsbn
            ? isSelected
              ? "bg-[#0CA522]"
              : "border-rl-border_line-light-01 bg-rl-common-white border hover:bg-gray-50"
            : "border-rl-border_line-light-01 cursor-not-allowed border bg-gray-100 opacity-50"
        }`}
      >
        {isSelected && hasValidIsbn && (
          <svg
            className="h-4 w-4 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2.5}
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
      </button>
    </div>
  )
})

BookItem.displayName = "BookItem"

export default BookItem
